import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TokenResponse } from '../_core/_interface/tokenSelsforce';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SyeService {

  private apiUrl = 'https://orders-britania-israel.sye.co.il/Store_Quotation_Json';

  constructor(private http: HttpClient) { }

  postQuotation(data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer BIHWlie5Biw0L6-M3-PU69BqSOGtucBwlGb1CmN5DpXvinIhddmNftSxcv94YFDMQiIhXrhOMlMZL6oQkMndjCH4JoAWYLoqSu89OpEwl1LbeqnfDHR9NAPs'
    });

    return this.http.post(this.apiUrl, data, { headers });
  }


  getProjectDetails(projectNumber: number): Observable<any> {
    let apiUrl = 'https://orders-britania-israel.sye.co.il/Get_Project_Json';
    let authToken = 'Bearer BIHWlie5Biw0L6-M3-PU69BqSOGtucBwlGb1CmN5DpXvinIhddmNftSxcv94YFDMQiIhXrhOMlMZL6oQkMndjCH4JoAWYLoqSu89OpEwl1LbeqnfDHR9NAPs';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': authToken
    });

    const body = {
      ProjectNumber: projectNumber
    };

    return this.http.post<any>('https://orders-britania-israel.sye.co.il/Get_Project_Json', body, { headers });
  }
}
